import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';
import { CurrentUserService } from 'services/currentUser';
import { getEvidenceOfInsuranceDocument, getMortgages } from 'common/source/utilities/policyInfoHelper';
import { openUrlInNewTab } from 'common/source/utilities/windowHelper';
import { ModalService } from 'common/source/services/modal';
import { ITimeoutService } from 'angular';

const module = angular.module('notify-mortgage-lender-section', []);

interface NotifyMortgageLenderSectionController extends angular.IStrictController {
    policyInfo: CustomerPolicyInfo;

    title: string;
    description: string;
    updateLenderInformation: () => void;
    updateLenderInformationMobile: () => void;
    downloadEvidenceOfInsurance: () => void;
    mortgages: Array<MortgageDetails>;
    lenderName: string;
    addEditLenderInformationLabel: string;
    evidenceOfInsuranceUrl: string;
}

module.component('notifyMortgageLenderSection', {
    template: template,
    bindings: {
        policyInfo: '<'
    },
    controller: function(
        this: NotifyMortgageLenderSectionController,
        currentUserService: CurrentUserService,
        modalService: ModalService,
        $timeout: ITimeoutService
    ) {
        const updateDisplay = () => {
            const evidenceOfInsuranceDocument = getEvidenceOfInsuranceDocument(this.policyInfo);
            this.evidenceOfInsuranceUrl = evidenceOfInsuranceDocument ? evidenceOfInsuranceDocument : '';

            this.mortgages = getMortgages(this.policyInfo);

            if (this.mortgages.length < 3) {
                this.addEditLenderInformationLabel = 'Need to notify an additional lender?';
            } else if (this.mortgages.length === 3) {
                this.addEditLenderInformationLabel = `Please limit to 3 lenders. Call us at
                <a href="tel:1-800-585-0705">800-585-0705</a> with any questions.`;
            }
        };

        this.$onInit = () => {
            this.title = 'Notify your mortgage lender';
            this.description = `If you need to provide Evidence of Insurance to your lender click below and we'll send it to them
                directly. You can also download a version for your files. For assistance give us a call at
                <br class="desktop-only"/> 1-800-585-0705.`;
            updateDisplay();
        };

        this.$onChanges = (changesObj) => {
            const policyInfo = changesObj.policyInfo;
            if (policyInfo && policyInfo.currentValue !== undefined) {
                $timeout(() => {
                    this.policyInfo = policyInfo.currentValue;
                    updateDisplay();
                });
            }
        };

        this.downloadEvidenceOfInsurance = () => {
            if (this.evidenceOfInsuranceUrl) {
                openUrlInNewTab(this.evidenceOfInsuranceUrl);
            }
        };

        this.updateLenderInformation = () => {
            modalService.openCloseableModal('notify-lender');
        };

        this.updateLenderInformationMobile = () => {
            modalService.openFullPageModal('notify-lender');
        };
    }
});

export { module };
